// extracted by mini-css-extract-plugin
export default {"listViewGrid":"PeopleListPage_listViewGrid__tIVbu"};